import * as yup from 'yup';
import { message } from './helpers';

export default yup.object().shape({
  public_key: yup.string().required(message('required', 'Public Key')),
  secret_key: yup.string().required(message('required', 'Secret Key')),
});
